import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

// FlowsProvider expects href: string (not null/undefined)
type FlowsLinkProps = Omit<React.ComponentProps<'a'>, 'href' | 'onClick'> & {
  href: string;
  onClick?: () => void;
};

export const Link = React.forwardRef<HTMLAnchorElement, FlowsLinkProps>(({ href, onClick, ...props }, ref) => {
  // Only call onClick with no arguments, as required by FlowsProvider
  const handleClick = () => {
    if (onClick) onClick();
  };
  return <RouterLink ref={ref} to={href} onClick={onClick ? handleClick : undefined} {...props} />;
});

export default Link;
